import { PAGE_INFO_FRAGMENT } from "@/hooks/usePagination";
import { gql, TypedDocumentNode } from "@apollo/client";
import { AuditLogVariables } from "./types";
import { SectionAuditEntry } from "../../types";
import { PageInfo } from "@/components/Pagination";

interface Variables extends AuditLogVariables {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
}

type Result = {
  section: {
    id: string;
    name: string;
    legacyId: string;
    auditLogPagination: {
      totalCount: number;
      pageInfo: PageInfo;
      nodes: SectionAuditEntry[];
    };
  };
};

export const WHODUNNIT_FRAGMENT = gql`
  fragment Whodunnit on BackofficeChangeformAuditEvent {
    whodunnit {
      __typename
      ... on BackofficeAdminUser {
        id
        email
      }
      ... on BackofficePerson {
        id
        displayName
      }
      ... on BackofficeUser {
        id
        name
        email
      }
    }
  }
`;

export const AUDIT_LOG_PAGINATION_QUERY: TypedDocumentNode<Result, Variables> = gql`
  query sectionAuditLog(
    $sectionId: ID!
    $startDateTime: ISO8601DateTime
    $endDateTime: ISO8601DateTime
    $searchQuery: String
    $categories: [BackofficeAuditEventCategory!]
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    section(id: $sectionId) {
      id
      name
      legacyId
      auditLogPagination(
        startDateTime: $startDateTime
        endDateTime: $endDateTime
        searchQuery: $searchQuery
        categories: $categories
        first: $first
        last: $last
        after: $after
        before: $before
      ) {
        nodes {
          id
          changedAt
          category
          description
          linkPath
          person {
            id
            pgaId
            displayName
            profilePhoto
            latestProgram {
              programType {
                id
                name
              }
            }
          }
          changeset {
            id
            typeOfData
            oldValue
            newValue
          }
          ...Whodunnit
        }
        ...PageInfo
      }
    }
  }

  ${PAGE_INFO_FRAGMENT}
  ${WHODUNNIT_FRAGMENT}
`;
